import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const CommentsAlt = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 8H11C9.3 8 8 9.3 8 11V16.3C8 18 9.3 19.3 11 19.3H17.9L20.3 21.7C20.7 22.1 21.3 22.1 21.7 21.7C21.9 21.5 22 21.3 22 21V11C22 9.3 20.7 8 19 8ZM18 6.5V5C18 3.3 16.7 2 15 2H5C3.3 2 2 3.3 2 5V17C2 17.6 2.4 18 3 18C3.3 18 3.5 17.9 3.7 17.7L6.5 14.9V11C6.5 8.5 8.5 6.5 11 6.5H18Z"
      fill="currentColor"
    />
  </svg>
)

export default CommentsAlt
